import React, { useState, useEffect } from 'react';
import { getAllocations } from '../services/api';

const TradeHistory = () => {
  const [allocations, setAllocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [stats, setStats] = useState({
    totalProfit: 0,
    totalLoss: 0,
    winningTrades: 0,
    losingTrades: 0,
  });

  useEffect(() => {
    fetchAllocations();
  }, []);

  const fetchAllocations = async () => {
    try {
      const response = await getAllocations();
      if (response.data.success) {
        const data = response.data.allocations;
        setAllocations(data);
        
        let profit = 0, loss = 0, wins = 0, losses = 0;
        data.forEach(trade => {
          const pnl = parseFloat(trade.pnl_allocated_usdt);
          if (pnl > 0) {
            profit += pnl;
            wins++;
          } else if (pnl < 0) {
            loss += Math.abs(pnl);
            losses++;
          }
        });
        
        setStats({
          totalProfit: profit,
          totalLoss: loss,
          winningTrades: wins,
          losingTrades: losses,
        });
      }
    } catch (error) {
      console.error('Failed to fetch allocations:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-96">
        <div className="animate-pulse text-gray-400">Loading trade history...</div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h1 className="text-xl font-bold text-white">Trade History & P&L</h1>
      
      {/* Stats Summary */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="stat-card">
          <p className="text-gray-400 text-sm">Total Profit</p>
          <p className="text-2xl font-bold text-green-500">+{stats.totalProfit.toFixed(2)} USDT</p>
        </div>
        <div className="stat-card">
          <p className="text-gray-400 text-sm">Total Loss</p>
          <p className="text-2xl font-bold text-red-500">-{stats.totalLoss.toFixed(2)} USDT</p>
        </div>
        <div className="stat-card">
          <p className="text-gray-400 text-sm">Winning Trades</p>
          <p className="text-2xl font-bold text-green-500">{stats.winningTrades}</p>
        </div>
        <div className="stat-card">
          <p className="text-gray-400 text-sm">Losing Trades</p>
          <p className="text-2xl font-bold text-red-500">{stats.losingTrades}</p>
        </div>
      </div>
      
      {/* Trade Table */}
      <div className="card p-6">
        <h2 className="text-lg font-semibold text-white mb-4">All Trades</h2>
        
        {allocations.length === 0 ? (
          <p className="text-gray-500 text-center py-8">No trades executed yet</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="table-dark w-full">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Coin</th>
                  <th>Direction</th>
                  <th>P&L</th>
                  <th>Pool Share</th>
                  <th>Balance After</th>
                </tr>
              </thead>
              <tbody>
                {allocations.map((trade) => (
                  <tr key={trade.id}>
                    <td className="text-gray-400 text-sm">
                      {new Date(trade.created_at).toLocaleString()}
                    </td>
                    <td className="font-medium">{trade.coin_ticker}</td>
                    <td>
                      <span className={`badge-${trade.direction === 'LONG' ? 'success' : 'danger'}`}>
                        {trade.direction}
                      </span>
                    </td>
                    <td>
                      <span className={parseFloat(trade.pnl_allocated_usdt) >= 0 ? 'text-green-500' : 'text-red-500'}>
                        {parseFloat(trade.pnl_allocated_usdt) >= 0 ? '+' : ''}
                        {parseFloat(trade.pnl_allocated_usdt).toFixed(4)} USDT
                      </span>
                    </td>
                    <td className="text-gray-400">
                      {parseFloat(trade.pool_share_percent).toFixed(2)}%
                    </td>
                    <td className="font-medium">
                      {parseFloat(trade.equity_after_usdt).toFixed(2)} USDT
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default TradeHistory;